import t from "./translate";

export default function buildAdminNavigation({ workspaceSchool } = {}) {
  if (workspaceSchool?.id) {
    return [
      {
        section: t("shared.admin_navigation.workspace_section"),
        items: [
          { label: t("shared.admin_navigation.items.overview"), icon: "fa-chart-pie", href: `/admin/schools/${workspaceSchool.id}/workspace`, sectionKey: "overview" },
          { label: t("shared.admin_navigation.items.announcements"), icon: "fa-bullhorn", href: `/admin/announcements?workspace_school_id=${workspaceSchool.id}&workspace_section=overview`, matchPath: "/admin/announcements" },
          { label: t("shared.admin_navigation.items.messages"), icon: "fa-comments", href: `/admin/messages?workspace_school_id=${workspaceSchool.id}`, matchPath: "/admin/messages" },
          { label: t("shared.admin_navigation.items.people"), icon: "fa-users", href: `/admin/schools/${workspaceSchool.id}/workspace/people`, sectionKey: "people" },
          { label: t("shared.admin_navigation.items.academics"), icon: "fa-graduation-cap", href: `/admin/schools/${workspaceSchool.id}/workspace/academics`, sectionKey: "academics" },
          { label: t("shared.admin_navigation.items.teaching"), icon: "fa-chalkboard-user", href: `/admin/schools/${workspaceSchool.id}/workspace/teaching`, sectionKey: "teaching" },
          { label: t("shared.admin_navigation.items.operations"), icon: "fa-clipboard-list", href: `/admin/schools/${workspaceSchool.id}/workspace/operations`, sectionKey: "operations" },
          { label: t("shared.admin_navigation.items.administrators"), icon: "fa-user-shield", href: `/admin/schools/${workspaceSchool.id}/workspace/administrators`, sectionKey: "administrators" },
          { label: t("shared.admin_navigation.items.subscription"), icon: "fa-file-invoice", href: `/admin/schools/${workspaceSchool.id}/workspace/subscription`, sectionKey: "subscription" }
        ]
      }
    ];
  }

  return [
    {
      section: t("shared.admin_navigation.platform_section"),
      items: [
        { label: t("shared.admin_navigation.items.overview"), icon: "fa-chart-pie", href: "/admin" },
        { label: t("shared.admin_navigation.items.platform_users"), icon: "fa-user-shield", href: "/admin/users" },
        { label: t("shared.admin_navigation.items.tenants"), icon: "fa-building", href: "/admin/tenants" },
        { label: t("shared.admin_navigation.items.domains"), icon: "fa-globe", href: "/admin/domains" },
        { label: t("shared.admin_navigation.items.jobs"), icon: "fa-list-check", href: "/admin/sidekiq" },
        { label: t("shared.admin_navigation.items.settings"), icon: "fa-gear", href: "/admin/settings" }
      ]
    }
  ];
}
